export default __webpack_public_path__ + "img/allergy-peanuts.c6e4bb64477bf1da4fe003fcd5bd7dae.svg";